import {
  getSystemInfo,
} from '@/api/systeminfoserv'

export default {
  state: {
    state_SystemInfo_GetSystemInfoResult: null,
  },
  mutations: {
    SET_SYSTEMINFO_GETSYSTEMINFO_RESULT: (state, rst) => {
      state.state_SystemInfo_GetSystemInfoResult = rst;
    },
  },
  actions: {
    SystemInfoServ_GetSystemInfo({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getSystemInfo(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SYSTEMINFO_GETSYSTEMINFO_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SYSTEMINFO_GETSYSTEMINFO_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_SystemInfo_GetSystemInfoResult: state => {
      return state.state_SystemInfo_GetSystemInfoResult;
    },
  }
}